import createReactComponent from '../createReactComponent';
export default createReactComponent('dots', 'Dots', [["path",{"d":"M12 12.313v-.626m5 .626v-.626m-10 .626v-.626","key":"svg-0"}]]);